import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import style from '../css/Login.module.css';
import image from '../images/login.png';
import image1 from '../images/logo.png';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Login = () => {
	const [agentId, setAgentId] = useState('');
	const [password, setPassword] = useState('');
	const [showPassword, setShowPassword] = useState(false);
	const [error, setError] = useState('');
	const navigate = useNavigate();

	// Load saved credentials on mount
	useEffect(() => {
		const savedAgentId = localStorage.getItem('saved_agent_id');
		const savedPassword = localStorage.getItem('saved_password');
		if (savedAgentId && savedPassword) {
			setAgentId(savedAgentId);
			setPassword(savedPassword);
		}
	}, []);

	const handleLogin = async () => {
		if (!agentId || !password) {
			setError('Please fill in all fields');
			return;
		}

		try {
			const response = await axios.post(
				'https://hometech-repairs.in/homeTech/login.php',
				{ agent_id: agentId, password }
			);

			if (response.data.status) {
				// Check if account status is "Active"
				if (response.data.user.status === 'Active') {
					setError('Success: ' + response.data.msg);

					// Save user ID and credentials in local storage
					localStorage.setItem('user_id', response.data.user.id);
					localStorage.setItem('saved_agent_id', agentId);
					localStorage.setItem('saved_password', password);

					navigate('/new-booking');
				} else {
					setError('Your account is deactivated, contact company.');
				}
			} else {
				setError('Login Failed: ' + response.data.msg);
			}
		} catch (error) {
			console.error(error);
			setError('An error occurred. Please try again later.');
		}
	};

	return (
		<div className={style.container}>
			<div className={style.card}>
				<h3 style={{textAlign:'center'}}  >Home-Tech Repairs</h3> 
				<img src={image} alt="Login" className={style.image} />

				<div className={style.textCont}>
					<div className={style.passwordDiv}>
						<input
							type="text"
							value={agentId}
							onChange={(e) => setAgentId(e.target.value)}
							className={style.input}
							placeholder="Agent ID"
						/>
					</div>

					<div className={style.passwordDiv}>
						<input
							type={showPassword ? 'text' : 'password'}
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							className={style.passinput}
							placeholder="Password"
						/>
						<p onClick={() => setShowPassword(!showPassword)}>
							{showPassword ? (
								<FaEyeSlash size={20} color="black" />
							) : (
								<FaEye size={20} color="black" />
							)}
						</p>
					</div>

					<div onClick={handleLogin} className={style.button}>
						Login
					</div>

					<p>{error}</p>

					<Link className={style.btn} to={'admin-login'}>
						Admin Login
					</Link>
				</div> 
			</div>
		</div>
	);
};

export default Login;
